import { render, staticRenderFns } from "./liveClass.vue?vue&type=template&id=17b26f5a&scoped=true"
import script from "./liveClass.vue?vue&type=script&lang=js"
export * from "./liveClass.vue?vue&type=script&lang=js"
import style0 from "./liveClass.vue?vue&type=style&index=0&id=17b26f5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b26f5a",
  null
  
)

export default component.exports